import { render, staticRenderFns } from "./DeleteConfirmationDialog2.vue?vue&type=template&id=23364067&"
import script from "./DeleteConfirmationDialog2.vue?vue&type=script&lang=js&"
export * from "./DeleteConfirmationDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports